import { ErrorMessage, Field, Form, Formik } from 'formik';


import React from 'react';
import { Card } from 'react-bootstrap';
import Container from 'react-bootstrap/Container';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';
import { myFirestore } from '../../../services/firebase'
import * as Yup from 'yup';

import './feedbackform.css';



class Feedbackform extends React.Component {
  constructor(props) {
    super(props)

    this.uid = this.props.auth.uid;
    this.profile=this.props.profile;

  }


  saveform = (fields) => {
    console.log(fields, this.uid)
   
    myFirestore
      .collection('feedbackform')
      .doc(this.uid)
      .set({
        id: this.uid,
        feedback: fields.feedback,
        thoughtsofliving: fields.thoughtsofliving,
        currentthoughtsofliving: fields.currentthoughtsofliving,
        substance: fields.substance,
        othersubstance: fields.othersubstance,
        
        

        frequencyofusage: fields.frequencyofusage,
        psychiatricillness: fields.psychiatricillness,
        incidentsofsuicide: fields.incidentsofsuicide,
        name: fields.name,
        relation: fields.relation,
        contactdetails: fields.contactdetails

      },
        { merge: true })
      .then(() => {
        this.props.showToast(1,'FeedBack submitted sucessfully')
        
        if(this.props.profile.showIntakeForm3){
          this.props.history.push('/intakeform3')
        }
        else{
          this.props.history.push('/')
        }
        
        
        

      })
      .catch(err => {
        this.props.showToast(0, err.toString())
      })

  }

  handleSubmit = (values, {
    setSubmitting
  }) => {

    alert(JSON.stringify(values, null, 2));

    setSubmitting(false);

    return;
  }


  render() {
    const { auth } = this.props;
    if (!auth.uid) return <Redirect to='/signin' />

    return (
      <>
        <Formik
          initialValues={{

            feedback: '',
            thoughtsofliving: '',
            currentthoughtsofliving: '',
            substance: [],
            othersubstance: '',
            
            other: false,

            frequencyofusage: '',
            psychiatricillness: [],
            incidentsofsuicide: '',
            name: '',
            relation: '',
            contactdetails: ''
          }}
          validationSchema={Yup.object().shape({


            feedback: Yup.string()
              .required('feedback is required'),
            othersubstance: Yup.string()
              .when("other", {
                is: true,
                then: Yup.string().required('Other is required'),
              }),

            thoughtsofliving: Yup.string()
              .required('Required'),
          })}
          onSubmit={fields => {


            this.saveform(fields);

          }}

        >
          {({ errors, touched, values }) => (



            <Container className="form-container" fluid>

              <Card className="form-card">
                <div className="row justify-content-center">
                  <h2 style={{ fontWeight: 'bolder', padding: '1rem' }}>Please give your valuable FeedBack </h2>
                </div>
                <Form>




                  <div className="form-group ">
                    <label htmlFor="feedback">Your feedback of the Peer Counselling session :  </label>
                    <Field name="feedback" type="text" className={'form-control' + (errors.feedback && touched.feedback ? ' is-invalid' : '')} />
                    <ErrorMessage name="feedback" component="div" className="invalid-feedback" />
                  </div>


                  <div className="form-group">
                    <label htmlFor="thoughtsofliving">Have you ever had feelings or thoughts that you didn't want to live? </label>
                    <Field name="thoughtsofliving" type="text" className={'form-control' + (errors.thoughtsofliving && touched.thoughtsofliving ? ' is-invalid' : '')} />
                    <ErrorMessage name="thoughtsofliving" component="div" className="invalid-feedback" />
                  </div>
                  <div className="form-group">
                    <label htmlFor="currentthoughtsofliving">Do you currently feel that you don't want to live? </label>
                    <Field name="currentthoughtsofliving" type="text" className={'form-control' + (errors.currentthoughtsofliving && touched.currentthoughtsofliving ? ' is-invalid' : '')} />
                    <ErrorMessage name="currentthoughtsofliving" component="div" className="invalid-feedback" />
                  </div>

                  <div className="form-group ">
                    <label htmlFor="text">Substance Use:</label>

                    <div className='row form-group'>

                      <div className="form-group form-check  ">
                        <Field type="checkbox" name="substance" value='Alcohol' className={'form-check-input '} />
                        <label htmlFor="isConsent" className="form-check-label">Alcohol</label>
                        <ErrorMessage name="isConsent" component="div" className="invalid-feedback" />
                      </div>
                      <div className="form-group form-check  ">
                        <Field type="checkbox" name="substance" value='Cigarettes' className={'form-check-input '} />
                        <label htmlFor="substance" className="form-check-label">Cigarettes</label>
                        <ErrorMessage name="substance" component="div" className="invalid-feedback" />
                      </div>
                      <div className="form-group form-check  ">
                        <Field type="checkbox" name="substance" value='Marijuana' className={'form-check-input '} />
                        <label htmlFor="substance" className="form-check-label">Marijuana</label>
                        <ErrorMessage name="substance" component="div" className="invalid-feedback" />
                      </div>
                      <div className="form-group form-check  ">
                        <Field type="checkbox" name="other" className={'form-check-input '} />
                        <label htmlFor="other" className="form-check-label">Other</label>
                        <ErrorMessage name="other" component="div" className="invalid-feedback" />

                      </div>
                      {values.other &&
                        <div className="form-group">

                          <Field name="othersubstance" type="text" className={'form-control' + (errors.othersubstance && touched.othersubstance ? ' is-invalid' : '')} />
                          <ErrorMessage name="othersubstance" component="div" className="invalid-feedback" />
                        </div>
                      }


                    </div>


                  </div>
                  <div className="form-group">
                    <label htmlFor="frequencyofusage">Frequency of usage :</label>
                    <Field name="frequencyofusage" type="text" className={'form-control' + (errors.frequencyofusage && touched.frequencyofusage ? ' is-invalid' : '')} />
                    <ErrorMessage name="frequencyofusage" component="div" className="invalid-feedback" />
                  </div>
                  <div className="form-group ">
                    <label htmlFor="text">Any family history of psychiatric illness : (please specify relation with the person) </label>

                    <div className='row form-group'>

                      <div className="form-group form-check  ">
                        <Field type="checkbox" name="psychiatricillness" value='Depression' className={'form-check-input '} />
                        <label htmlFor="psychiatricillness" className="form-check-label">Depression</label>
                        <ErrorMessage name="psychiatricillness" component="div" className="invalid-feedback" />
                      </div>
                      <div className="form-group form-check  ">
                        <Field type="checkbox" name="psychiatricillness" value='Anxiety' className={'form-check-input '} />
                        <label htmlFor="psychiatricillness" className="form-check-label">Anxiety</label>
                        <ErrorMessage name="psychiatricillness" component="div" className="invalid-feedback" />
                      </div>
                      <div className="form-group form-check  ">
                        <Field type="checkbox" name="psychiatricillness" value='OCD' className={'form-check-input '} />
                        <label htmlFor="psychiatricillness" className="form-check-label">OCD</label>
                        <ErrorMessage name="psychiatricillness" component="div" className="invalid-feedback" />
                      </div>
                      <div className="form-group form-check  ">
                        <Field type="checkbox" name="psychiatricillness" value='Schizophrenia' className={'form-check-input '} />
                        <label htmlFor="psychiatricillness" className="form-check-label">Schizophrenia</label>
                        <ErrorMessage name="psychiatricillness" component="div" className="invalid-feedback" />
                      </div>
                      <div className="form-group form-check  ">
                        <Field type="checkbox" name="psychiatricillness" value='Substance Abuse' className={'form-check-input '} />
                        <label htmlFor="psychiatricillness" className="form-check-label">Substance Abuse</label>
                        <ErrorMessage name="psychiatricillness" component="div" className="invalid-feedback" />
                      </div>


                    </div>


                  </div>
                  <div className="form-group">
                    <label htmlFor="incidentsofsuicide">Any incidents of suicide in your family? (please specify relation with the person)</label>
                    <Field name="incidentsofsuicide" type="text" className={'form-control' + (errors.incidentsofsuicide && touched.incidentsofsuicide ? ' is-invalid' : '')} />
                    <ErrorMessage name="incidentsofsuicide" component="div" className="invalid-feedback" />
                  </div>
                  <div className="form-group">
                    <label htmlFor="">Emergency Contact details : <br />
                      ( Ideally this should be someone you feel physically and emotionally safe with. )</label>

                  </div>

                  <div className="form-group row">
                    <label htmlFor="name" className="col-sm-2 col-form-label">Name: </label>
                    <div className="col-sm-10 col-lg-10">
                      <Field name="name" type="text" className={'form-control' + (errors.name && touched.name ? ' is-invalid' : '')} />
                      <ErrorMessage name="name" component="div" className="invalid-feedback" />
                    </div>
                  </div>
                  <div className="form-group row">
                    <label htmlFor="relation" className="col-sm-2 col-form-label">Relation: </label>
                    <div className="col-sm-10 col-lg-10">
                      <Field name="relation" type="text" className={'form-control' + (errors.relation && touched.relation ? ' is-invalid' : '')} />
                      <ErrorMessage name="relation" component="div" className="invalid-feedback" />
                    </div>
                  </div>
                  <div className="form-group row">
                    <label htmlFor="contactdetails" className="col-sm-2 col-form-label">Email/Phone no: </label>
                    <div className="col-sm-10 col-lg-10">
                      <Field name="contactdetails" type="text" className={'form-control' + (errors.contactdetails && touched.contactdetails ? ' is-invalid' : '')} />
                      <ErrorMessage name="contactdetails" component="div" className="invalid-feedback" />
                    </div>
                  </div>

                  <div className="row justify-content-center">

                    <button type="submit" className="btn button mr-2 ">Submit </button>
                    <button type="reset" className="btn" style={{ width: '15rem', borderColor: '#40817a', borderRadius: '1rem', margin: '0.2rem' }}>Reset</button>
                  </div>

                </Form>
              </Card>
              {console.table(values)}
            </Container>





          )}

        </Formik>
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    auth: state.firebase.auth,
    authError: state.auth.authError,
    profile: state.firebase.profile
  }
}



export default connect(mapStateToProps)(Feedbackform)
